import { useStore } from "@/stores/useStore";
import { Button } from "@/components/base/Button";
import { LogOutIcon, Menu as MenuIcon } from "lucide-react";
import { Link } from "react-router-dom";
import mainLogo from "@/assets/RouteMeLogo.png";

export interface HeaderProps {
  onMenuClick: () => void;
}

export const Header = ({ onMenuClick }: HeaderProps) => {
  const { authState } = useStore();
  const logout = useStore((s) => s.logout);

  const handleClickLogout = () => {
    logout();
  };

  return (
    <div className="text-lg flex flex-row justify-between items-center px-1 py-1 shadow-2xl bg-secondary text-secondary-foreground">
      <Button
        variant="ghost"
        size="icon"
        onClick={onMenuClick}
        className="m-2"
        disabled={authState === "unauthenticated"}
      >
        <MenuIcon />
      </Button>
      <div className="flex flex-row gap-4 items-center">
        <img src={mainLogo} className="h-10" alt="routeme-logo" />
        <h1 className="text-2xl hidden sm:flex">RouteMe</h1>
      </div>
      <div className="flex-grow"></div>
      <div>
        <div className="flex flex-row items-end gap-4">
          {authState === "unauthenticated" && (
            <Link
              className="px-10 hidden sm:flex"
              to="login"
              aria-label="Login"
            >
              Login
            </Link>
          )}
          {authState === "unauthenticated" && (
            <Link
              className="hidden px-10 sm:flex"
              to="register"
              aria-label="Sign up"
            >
              Signup
            </Link>
          )}
          {authState !== "unauthenticated" && (
            <>
              <Button
                variant="ghost"
                onClick={handleClickLogout}
                aria-label="Logout"
              >
                <LogOutIcon />
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
